import { gtmGlobal } from '~/helpers/gtm.js';

export default function ({ $gtm, $config, app, $cookies }) {
	if ($cookies.get('cookies-gtm') === 1) {
		gtmGlobal({ $gtm, $config, locale: app.i18n.locale });
	}
}
